import React from 'react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-noche" data-id="element-16" data-mp="axhve37bl2g">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-17" data-mp="3iqq6joq1ikvu">
        <h2 id="beneficios" className="font-display text-[1.6rem] uppercase leading-[1.08] text-white sm:text-4xl" data-id="element-18" data-mp="3iodmn60q20g5">
          ¿Qué puede cambiar cuando{' '}
          <span className="text-oro" data-id="element-19" data-mp="38u4zyyydh1pw">empezás?</span>
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-white/90" data-id="element-20" data-mp="3drwqbojdcfrz">
          Tener los contenidos organizados puede transformar tu manera de
          enseñar y estudiar.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-21" data-mp="34r8b4qi8o9di">
          {benefits.map((benefit, i) => <Reveal key={benefit.title} as="li" delay={i * 0.03} className="h-full rounded-xl border-2 border-ciencia bg-white p-2.5 text-left" data-id="element-22" data-mp="y1ajn4txzgbh" data-mpi={i}>
              <h3 className="font-sub text-sm font-extrabold leading-tight text-noche" data-id="element-23" data-mp="2bdmdux6rp4yx">
                {benefit.title}
              </h3>
              <p className="mt-0.5 text-xs leading-snug text-noche-dark/80 sm:text-sm" data-id="element-24" data-mp="2l4z63pwh9x5h">
                {benefit.desc}
              </p>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}